export default {
  name: 'predictions',
  data: () => ({
    tabsArr: [
      {
        title: 'Predictions',
        route: '/app/dashboard',
        disabled: false
      },
      {
        title: 'Results',
        route: '/app/dashboard/result',
        disabled: false
      },
      {
        title: 'Leaderboards',
        route: '/app/dashboard/leaderboard',
        disabled: false
      }
    ]
  }),
  activated() {
    this.$store.commit('SET_PAGE_TITLE', 'dashboard')
    this.$store.commit('SET_HEADER_TABS', this.tabsArr)
  },
  deactivated() {
    this.$store.commit('SET_HEADER_TABS', null)
  }
}
